import { tv, type VariantProps } from 'tailwind-variants';
export type AtDividerVariants = VariantProps<typeof atDivider>;

const atDivider = tv({
  base: 'border-0',
  slots: {},
  variants: {
    direction: {
      horizontal: 'w-inherit',
      vertical: 'h-inherit',
    },
    intent: {
      thicker: '',
      thick: '',
      thin: '',
    },
    color: {
      white: 'bg-[var(--color-ui-knockout-primary)]',
      grey: 'bg-[var(--color-ui-grid-secondary)]',
      black: 'bg-skin-ui-fill-primary',
      green: 'bg-skin-stroke-tertiary',
    },
  },
  compoundVariants: [
    {
      direction: 'horizontal',
      intent: 'thicker',
      className: 'h-0.03',
    },
    {
      direction: 'vertical',
      intent: 'thicker',
      className: 'w-0.03',
    },
    {
      direction: 'horizontal',
      intent: 'thick',
      className: 'h-0.5',
    },
    {
      direction: 'horizontal',
      intent: 'thin',
      className: 'h-0.01',
    },
    {
      direction: 'vertical',
      intent: 'thick',
      className: 'w-0.5',
    },
    {
      direction: 'vertical',
      intent: 'thin',
      className: 'w-0.01',
    },
  ],
});

export default atDivider;
